module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inputLabel":"Search","noItemsText":"No items to show.","noResultsText":"Your search didn\u0027t match any results."},"fi":{"inputLabel":"Haku","noItemsText":"Ei näytettäviä kohteita.","noResultsText":"Ei hakutuloksia."},"sv":{"inputLabel":"Sök","noItemsText":"Inga objekt att visa.","noResultsText":"Inga sökresultat"}}')
  delete Component.options._Ctor
}
